import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './footer4.css'

const Footer4 = (props) => {
  return (
    <footer className="footer4-footer7 thq-section-padding">
      <div className="footer4-max-width thq-section-max-width">
        <div className="footer4-content">
          <div className="footer4-logo1">
            <Link to="/" className="footer4-navlink1">
              <img
                alt={props.logoAlt}
                src={props.logoSrc}
                className="footer4-logo2"
              />
            </Link>
          </div>
          <div className="footer4-links">
            <Link to="/about" className="footer4-navlink2">
              {props.link1 ?? (
                <Fragment>
                  <span className="footer4-text15 thq-body-small">
                    About Us
                  </span>
                </Fragment>
              )}
            </Link>
            <Link to="/blog" className="footer4-navlink3">
              {props.link4 ?? (
                <Fragment>
                  <span className="footer4-text19 thq-body-small">
                    Media &amp; News
                  </span>
                </Fragment>
              )}
            </Link>
            <Link to="/resources" className="footer4-navlink4">
              {props.link2 ?? (
                <Fragment>
                  <span className="footer4-text17 thq-body-small">
                    Resources
                  </span>
                </Fragment>
              )}
            </Link>
            
            <Link to="/contact" className="footer4-navlink4">
              {props.link2 ?? (
                <Fragment>
                  <span className="footer4-text17 thq-body-small">
                    Contact Us
                  </span>
                </Fragment>
              )}
            </Link>
          </div>
        </div>
        <div className="footer4-credits">
          <div className="thq-divider-horizontal"></div>
          <div className="footer4-row">
            <div className="footer4-container">
              <span className="thq-body-small">
                Copyright © 2024 Commonwealth Secretariat
              </span>
            </div>
            
            <div className="footer4-footer-links">
              <span>
                {props.privacyLink ?? (
                  <Fragment>
                    <span className="footer4-text20 thq-body-small">
                      <a href="https://thecommonwealth.org/privacy-policy">Privacy Policy</a>
                    </span>
                  </Fragment>
                )}
              </span>
              <span>
                {props.termsLink ?? (
                  <Fragment>
                    <span className="footer4-text14 thq-body-small">
                      <a href="https://thecommonwealth.org/terms-conditions">Terms & Conditions</a>
                    </span>
                  </Fragment>
                )}
              </span>
              <span>
                {props.cookiesLink ?? (
                  <Fragment>
                    <span className="footer4-text18 thq-body-small">
                      <a href="https://thecommonwealth.org/cookies">Cookies Policy</a>
                    </span>
                  </Fragment>
                )}
              </span>
            </div> 
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer4.defaultProps = {
  termsLink: undefined,
  link1: undefined,
  link5: undefined,
  link2: undefined,
  cookiesLink: undefined,
  link4: undefined,
  logoSrc: '/caic-logo.png',
  privacyLink: undefined,
  logoAlt: 'Logo',
}

Footer4.propTypes = {
  termsLink: PropTypes.element,
  link1: PropTypes.element,
  link5: PropTypes.element,
  link2: PropTypes.element,
  cookiesLink: PropTypes.element,
  link4: PropTypes.element,
  logoSrc: PropTypes.string,
  privacyLink: PropTypes.element,
  logoAlt: PropTypes.string,
}

export default Footer4
